import { FunctionComponent, useState } from 'react'
import styled from 'styled-components'

import Button from '../../../components/display/Button'
import LazyImage from '../../../components/display/LazyImage'
import FullscreenSlider from '../../../components/display/FullscreenSlider'

export const DesktopListingHeaderWrapper = styled.div`
  position: relative;
  height: 0;
  padding-top: 37.777%;
  background-color: #333;

  ${LazyImage} {
    pointer-events: none;
    position: absolute;
    left: 0;
    top: 0;
  }
`

const ActionButton = styled(Button)`
  color: #333 !important;
  background-color: rgba(255, 255, 255, 0.9);
  transition: background-color 300ms ease-out;
  &:hover {
    background-color: white;
  }
`

const Wrapper = styled.div`
  display: flex;
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;

  ${ActionButton} {
    position: absolute;
    right: 40px;
    bottom: 40px;
  }
`

const Main = styled.div<{ pointer?: boolean }>`
  ${({ pointer }) =>
    pointer &&
    `
    cursor: pointer;
  `}

  position: relative;
  flex: 1;
`

const Thumbs = styled.div`
  display: flex;
  flex-direction: column;

  width: 33.333%;
  height: 100%;

  border-left: 2px solid white;
`

const Thumb = styled.div`
  cursor: pointer;
  position: relative;
  flex: 1;

  &:first-child {
    border-bottom: 1px solid white;
  }

  &:last-child {
    border-top: 1px solid white;
  }
`

interface DesktopListingHeaderProps {
  photos: Pick<GQL_Photo, 'image' | 'position'>[]
  videos?: Array<{
    id: string
    streamUrl: string
    thumbnailUrl: string
    posterUrl: string
  }>
  video_url?: string
}

const DesktopListingHeader: FunctionComponent<DesktopListingHeaderProps> = ({
  photos,
  videos = [],
  video_url,
}) => {
  const [galleryOpen, setGalleryOpen] = useState(false)

  const handleGalleryOpen = () => setGalleryOpen(true)
  const handleGalleryClose = () => setGalleryOpen(false)

  const enableGallery = photos.length > 1

  const slides = [
    ...videos.map((video) => ({
      type: 'video',
      ...video,
    })),
    ...photos.map((photo) => ({
      type: 'photo',
      ...photo,
    })),
  ]

  return (
    <DesktopListingHeaderWrapper>
      <Wrapper>
        {photos[0] && (
          <Main
            onClick={enableGallery ? handleGalleryOpen : undefined}
            pointer={enableGallery}
          >
            {/* preload renders eager <img src> so a <noscript> fallback would
             * be redundant — and React 18 can't hydrate element children
             * inside <noscript> (parsed as text when JS is on). */}
            <LazyImage data-src={photos[0].image.hero} preload />
          </Main>
        )}

        {enableGallery && (
          <Thumbs>
            {photos[1] && (
              <Thumb onClick={handleGalleryOpen}>
                <LazyImage data-src={photos[1].image.medium} preload />
              </Thumb>
            )}
            {photos[2] && (
              <Thumb onClick={handleGalleryOpen}>
                <LazyImage data-src={photos[2].image.medium} preload />
              </Thumb>
            )}
          </Thumbs>
        )}

        {enableGallery && (
          <ActionButton onClick={handleGalleryOpen} white>
            View Photos
          </ActionButton>
        )}
      </Wrapper>

      <FullscreenSlider
        slides={slides}
        video_url={video_url}
        isOpen={galleryOpen}
        onRequestClose={handleGalleryClose}
      />
    </DesktopListingHeaderWrapper>
  )
}

export default DesktopListingHeader
